// index.ts — entry point for the turn-widget GM controls bundle.
//
// esbuild bundles everything reachable from here into
// includes/js/dist/turn-widget-bundle.js. All renderer exports get attached
// to window so side-panels-init can patch controls without importing this bundle's state.

import {
    renderTurnWidgetGMControls,
    patchTurnWidgetGMControls,
    ftTwgRenderHiddenInputs,
    ftTwgRenderRow1EncounterActions,
    ftTwgRenderRow2EncounterNavCampaignState,
    ftTwgRenderRowLinks,
    ftTwgRenderRow3CombatVisibility,
    ftTwgRenderRow4EncounterContentCampaignFeatures,
    ftTwgRenderRow5CombatTurnTimer,
} from './turn-widget-gm-controls';
import {
    changeEncounterLightType,
    changeEncounterWeather,
    changeEncounterLightTypeTo,
    changeEncounterWeatherTo,
} from './turn-widget-env-forms';
// Music form — renders inline into the same GM viewer pane as the env forms.
import { ftOpenMusicForm } from './turn-widget-music-form';

declare global {
    interface Window {
        renderTurnWidgetGMControls: typeof renderTurnWidgetGMControls;
        ftPatchTurnWidgetGMControls: typeof patchTurnWidgetGMControls;
        ftTwgRenderHiddenInputs: typeof ftTwgRenderHiddenInputs;
        ftTwgRenderRow1EncounterActions: typeof ftTwgRenderRow1EncounterActions;
        ftTwgRenderRow2EncounterNavCampaignState: typeof ftTwgRenderRow2EncounterNavCampaignState;
        ftTwgRenderRowLinks: typeof ftTwgRenderRowLinks;
        ftTwgRenderRow3CombatVisibility: typeof ftTwgRenderRow3CombatVisibility;
        ftTwgRenderRow4EncounterContentCampaignFeatures: typeof ftTwgRenderRow4EncounterContentCampaignFeatures;
        ftTwgRenderRow5CombatTurnTimer: typeof ftTwgRenderRow5CombatTurnTimer;
        // Encounter env-type forms (light / weather) — replace the old template.js globals.
        changeEncounterLightType: typeof changeEncounterLightType;
        changeEncounterWeather: typeof changeEncounterWeather;
        changeEncounterLightTypeTo: typeof changeEncounterLightTypeTo;
        changeEncounterWeatherTo: typeof changeEncounterWeatherTo;
        ftOpenMusicForm: typeof ftOpenMusicForm;
    }
}

Object.assign(window, {
    renderTurnWidgetGMControls,
    ftPatchTurnWidgetGMControls: patchTurnWidgetGMControls,
    ftTwgRenderHiddenInputs,
    ftTwgRenderRow1EncounterActions,
    ftTwgRenderRow2EncounterNavCampaignState,
    ftTwgRenderRowLinks,
    ftTwgRenderRow3CombatVisibility,
    ftTwgRenderRow4EncounterContentCampaignFeatures,
    ftTwgRenderRow5CombatTurnTimer,
    changeEncounterLightType,
    changeEncounterWeather,
    changeEncounterLightTypeTo,
    changeEncounterWeatherTo,
    ftOpenMusicForm,
});
